import { useEffectAsync } from '../../helpers';
import apiClient from '../../Services/ApiClient';
import {
	USER_FULL_INFO,
	USER_HEALTH_CARD,
	USER_RELATIONS,
	USER_VZP_DOCTORS,
} from '../UserInfo/UserData';
import { useState } from 'react';
import { useLazyPatientProfileDataQuery } from '../../graphql/graphql';

// @ts-ignore
export const useLoadProfile = (props: {
	userId: string;
	loadVerifyInformation: boolean;
	loadUserRelations: boolean;
	loadHealthCard: boolean;
}) => {
	const { userId, loadVerifyInformation, loadUserRelations, loadHealthCard } =
		props;
	const [user, setUser] = useState<any>(null);
	const [userRelations, setUserRelations] = useState(null);
	const [psychoQuestionnaire, setPsychoQuestionnaire] = useState(null);
	const [psychoQuestionnaireTheme, setPsychoQuestionnaireTheme] =
		useState(null);
	const [doctorsData, setDoctorsData] = useState(null);
	const [healthCard, setHealthCard] = useState(null);
	const [insuranceCard, setInsuranceCard] = useState(null);
	const [getPatientProfile] = useLazyPatientProfileDataQuery();
	const [isLoading, setIsLoading] = useState(false);

	// @ts-ignore
	const reload = async () => {
		setIsLoading(true);
		let result;

		if (userId) {
			result = await getPatientProfile({
				userId,
				useOriginalId: true,
			}).unwrap();
		}
		const tempUser = { ...result?.user } || null;
		const mappedMeta = {};
		for (const metaItem of tempUser.meta) {
			mappedMeta[metaItem.key] = metaItem.value;
		}
		tempUser.meta = mappedMeta;
		tempUser.originalMeta = result?.user?.meta;

		setUser(tempUser);

		const vzpData = result?.user?.vzpRegisteredDoctorsResult?.data || [];
		setDoctorsData(vzpData);

		const userRelationsData = result?.user?.userRelations || [];
		setUserRelations(userRelationsData);

		const userHealthCard = result?.user?.healthCard || null;
		setHealthCard(userHealthCard);
		setInsuranceCard({
			front: result?.user?.insuranceCardFrontThumbnailUrl,
			back: result?.user?.insuranceCardBackThumbnailUrl,
		});
		setIsLoading(false);
	};

	useEffectAsync(async () => {
		if (user && user.partner == 3 && user.originalId) {
			const { data: result } = await apiClient.get(
				'/user/' + user.originalId + '/questionnaire/psycho/result/last/',
			);
			setPsychoQuestionnaireTheme(
				result?.theme === 'green' ? 'rohlik' : 'danger',
			);
			setPsychoQuestionnaire(result);
		}
	}, [user]);

	// @ts-ignore
	useEffectAsync(async () => {
		await reload();
	});

	return {
		user,
		doctorsData,
		psychoQuestionnaire,
		psychoQuestionnaireTheme,
		userRelations,
		healthCard,
		insuranceCard,
		isLoading,
		reload,
	};
};
